import { useMemo, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { ResortTypeCard } from 'entities/tour/ui'

import ImageBag from 'shared/images/bag.svg'
import { EmptyPage } from 'shared/ui/empty-page'

import s from './styles.module.scss'

interface Props {
  searchResort?: string
  listTours?: {
    id: string | number
    name: string
    isActive?: boolean
  }[]
  onAllResorts?: (isAllSelected?: boolean) => void
  onClick?: (id: string | number) => void
}

const maxResortsForShowBtn = 2

export const ListResorts = ({
  searchResort,
  listTours,
  onClick,
  onAllResorts,
}: Props) => {
  const { t } = useTranslation()

  const [isAllSelected, setIsAllSelected] = useState<boolean>(() => {
    const listTours_ = listTours?.filter((tour) => tour.isActive)

    return listTours_?.length === listTours?.length
  })

  const onAllResortsClick = () => {
    setIsAllSelected(!isAllSelected)
    onAllResorts?.(!isAllSelected)
  }

  const onClickResort = (index: string | number) => {
    if (isAllSelected) setIsAllSelected(false)

    onClick?.(index)
  }

  const sortedTours = useMemo(() => {
    if (!searchResort) return listTours

    return listTours?.filter((resort) =>
      resort?.name?.toLocaleLowerCase()?.includes(searchResort),
    )
  }, [searchResort, listTours])

  return (
    <div className={s.container}>
      {!searchResort && (sortedTours?.length || 0) > maxResortsForShowBtn && (
        <ResortTypeCard
          isActive={isAllSelected}
          name={t('tours_block.all_excursions')}
          onClick={onAllResortsClick}
        />
      )}

      {sortedTours?.map((tour) => (
        <ResortTypeCard
          key={tour.id}
          name={tour.name}
          isActive={tour.isActive}
          onClick={() => onClickResort(tour.id)}
        />
      ))}

      {sortedTours?.length === 0 && (
        <div className={s.emptyBlock}>
          <EmptyPage
            image={ImageBag}
            title={t('tours_block.not_found')}
            subTitle={t('tours_block.try_again')}
          />
        </div>
      )}
    </div>
  )
}
